<dialog-header
  title="Voucher Fees"
  (onClose)="dialogRef.close()"
></dialog-header>

<div
  mat-dialog-content
  style="
    border-top: 1px solid lightgray;
    border-bottom: 1px solid lightgray;
    background-color: var(--app-container);
  "
>
  <div style="margin-top: 20px">
    <app-info-box
      [removePadding]="true"
      [canDismiss]="false"
      title="Why do we charge fees?"
      [body]="
        'We charge a small platform fee when you sell vouchers through Remy Rewards to cover two things: Stripe’s payment processing fees (1.5-3.25% + 20p per transaction), and the ongoing cost of maintaining and improving our platform. This includes secure voucher delivery, customer support, marketing tools, and redemption tracking. Our fees are designed to be fair — scaling down as the voucher value increases — ensuring merchants keep as much revenue as possible while benefiting from a reliable and growing ecosystem. Plus, a tiny portion helps keep Remy well-fed with dog treats. He’s a hard-working mascot, after all!'
      "
    ></app-info-box>
  </div>

  <div class="fee-tables">
    <div class="fee-structure">
      <table class="fee-table">
        <thead>
          <tr>
            <th>Voucher Cost</th>
            <th>Remy's Fee %</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let tier of feeStructure">
            <td>{{ tier.range }}</td>
            <td>{{ tier.percentage }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="examples">
      <h3>Example Calculations</h3>
      <table class="fee-table">
        <thead>
          <tr>
            <th>Voucher Cost</th>
            <th>Remy's Fee %</th>
            <th>Remy's Fee £</th>
            <th>Your Proceeds</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let example of examples">
            <td>£{{ example.cost.toFixed(2) }}</td>
            <td>{{ example.feePercent.toFixed(2) }}%</td>
            <td>£{{ example.feeAmount.toFixed(2) }}</td>
            <td>£{{ example.proceeds.toFixed(2) }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<div mat-dialog-actions align="end">
  <app-primary-button
    [title]="'Close'"
    (tapped)="close()"
    bgColor="var(--app-timber)"
    color="white"
  ></app-primary-button>
</div>
